/*
 * @Descripttion:
 * @version:
 * @Author: Raoxf
 * @Date: 2022-03-01 15:51:48
 * @LastEditors: Raoxf
 * @LastEditTime: 2023-03-21 19:17:49
 */

const Layout = () =>
  import(/* webpackChunkName: "base_dependent" */ "../components/Layout.vue");
const Login = () =>
  import(/* webpackChunkName: "login" */ "../views/Login.vue");
const resetPassword = () =>
  import(/* webpackChunkName: "login" */ "../views/account/resetPassword.vue");

/**
 * 服务管理模块
 */
const userManagement = () =>
  import(
    /* webpackChunkName: "service" */ "../views/service/user-management.vue"
  );
const userAdd = () =>
  import(/* webpackChunkName: "service" */ "../views/service/user-add.vue");

const NotFound = () => import(/* webpackChunkName: "user" */ "../page404.vue");

/*账户管理*/
const addUser = () =>
  import(/* webpackChunkName: "user" */ "../views/account/add-user.vue");
const accountInfo = () =>
  import(/* webpackChunkName: "user" */ "../views/account/account-info.vue");
const roleManagement = () =>
  import(/* webpackChunkName: "user" */ "../views/account/role-management.vue");
const menuManagement = () =>
  import(/* webpackChunkName: "user" */ "../views/account/menu-management.vue");
const cleanerList = () =>
  import(/* webpackChunkName: "user" */ "../views/account/cleaner-list.vue");
const companyList = () =>
  import(/* webpackChunkName: "user" */ "../views/account/company-list.vue");
const partnerList = () =>
  import(/* webpackChunkName: "user" */ "../views/partner/partner-list.vue");

/**
 * 配置模块
 */
const addCoupon = () =>
  import(/* webpackChunkName: "user" */ "../views/page-config/coupon-add.vue");
const couponConfig = () =>
  import(
    /* webpackChunkName: "user" */ "../views/page-config/coupon-config.vue"
  );
const couponDetail = () =>
  import(
    /* webpackChunkName: "user" */ "../views/page-config/coupon-details.vue"
  );
const homeManage = () =>
  import(/* webpackChunkName: "user" */ "../views/page-config/home-manage.vue");
const sceneList = () =>
  import(/* webpackChunkName: "user" */ "../views/page-config/scene-list.vue");
const systemConfig = () =>
  import(/* webpackChunkName: "user" */ "../views/account/systemConfig.vue");

/**
 * 商品模块
 */
const productList = () =>
  import(/* webpackChunkName: "user" */ "../views/product/product-list.vue");
const categoryList = () =>
  import(/* webpackChunkName: "user" */ "../views/product/category-list.vue");

/**
 * 订单模块
 */
const orderList = () =>
  import(/* webpackChunkName: "user" */ "../views/order/order-list.vue");
const orderDetail = () =>
  import(/* webpackChunkName: "user" */ "../views/order/order-detail.vue");

/**
 * 回收订单模块
 */
const recycleList = () =>
  import(/* webpackChunkName: "recycle" */ "../views/recycle/recycle-list.vue");
const recycleDetail = () =>
  import(
    /* webpackChunkName: "recycle" */ "../views/recycle/recycle-detail.vue"
  );

/**
 * 提现审核模块
 */
const withdrawList = () =>
  import(/* webpackChunkName: "withdraw" */ "../views/withdraw/withdraw-list.vue");

const components = {
  Layout,
  Login,
  NotFound,
  addUser,
  accountInfo,
  roleManagement,
  menuManagement,
  addCoupon,
  couponConfig,
  couponDetail,
  homeManage,
  sceneList,
  productList,
  categoryList,
  orderList,
  orderDetail,
  recycleList,
  recycleDetail,
  withdrawList,
  cleanerList,
  companyList,
  systemConfig,
  partnerList,
  resetPassword,
  userManagement,
  userAdd,
};

module.exports.default = module.exports = components;
